module.exports = __webpack_public_path__ + "img/home-active.9db42d94.svg";